import { useState } from "react"
import { useMutation } from "react-query"
import { globalState } from "../index"
import { AddNewTableRow } from "../../components/AddNewTableRow"
import { Commission, CommissionConfigScope } from "models/commissions"
import { createCommission } from "api/commissions"
import { ApiError, ErrorsMap } from "api/http/utils"

type Props = {
  onClose: VoidFunction
  isLoading: boolean
  data?: Commission[]
  configScope?: CommissionConfigScope
  configOwnerId?: string
  queryKeyParam?: string
}

export const AddNewCommission = (props: Props) => {
  const { onClose, isLoading, data, configOwnerId, configScope } = props
  const [state, setState] = useState<Partial<Commission> | undefined>({})

  const [errors, setErrors] = useState<ErrorsMap | undefined>()

  // ** create new commission
  const [create] = useMutation(createCommission, {
    onSuccess: (d: Commission) => {
      globalState.addRow(d)
      setErrors(undefined)
      onClose()
    },
    onError: (err: ApiError) => {
      const error = err as ApiError
      const errorMap = error?.errorsMap ?? {}
      setErrors(errorMap)
    },
  })

  const onChange = (name: string, value: string) => {
    setState((s) => ({ ...s, [name]: value }))
    setErrors(undefined)
  }

  const onSelectChange = (
    option: {
      label: string | undefined
      value: string | undefined
    } | null,
  ) => {
    setState(data?.find((d) => d?.label === option?.label))
    setErrors(undefined)
  }

  const handleCreate = () => {
    const pld = {
      configOwnerId,
      configScope,
      label: state?.label,
      amountType: state?.amountType,
      amount: state?.amount,
      semantic: state?.semantic,
      mediaTypeSemantics: state?.mediaTypeSemantics || [],
    }
    create(pld)
  }

  return (
    <AddNewTableRow<Commission>
      onClose={onClose}
      isLoading={isLoading}
      onChange={onChange}
      onSelectChange={onSelectChange}
      handleCreate={handleCreate}
      data={data}
      row={state}
      errors={errors}
      labelParam="admin.commissions"
      fieldName="label"
    />
  )
}
